export default __webpack_public_path__ + "images/37_1_image.jpg";